// src/mocks/handlers/sources/index.ts

import { commercialTermsHandler } from './commercialTermsHandler';

export const sourcesHandlers = [commercialTermsHandler];
